export default __webpack_public_path__ + "static/media/ttg-white.4bdda4ae.svg";